<template>
    <section class="app-main">

        <div class="top-bar">
            <el-input placeholder="输入邮箱或者手机号" v-model="value" @change="search" style="width:200px;margin-right:25px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- <el-button  class="top-btn" type="success" plain @click="dialogVisible = true">群发短信</el-button>
            <el-button  type="primary" plain @click="handelReset">重置发送用户</el-button> -->
            <!-- <el-button  class="top-btn" type="success" plain @click="handleBatch(2)">群发邮件</el-button> -->
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无用户" height="560">
                <!-- <el-table-column type="selection"  width="100"     align="center"> </el-table-column> -->
                <el-table-column prop="user_retain.user.nickname"   label="昵称"    align="center"></el-table-column>
                <!-- <el-table-column prop="realname"   label="姓名"    align="center"> </el-table-column> -->
                <!-- <el-table-column prop="sex_title"  label="性别"    align="center"> </el-table-column> -->
                <el-table-column prop="user_retain.user.phone"      label="手机号"  align="center"> </el-table-column>
                <el-table-column prop="user_retain.user.email"      label="邮箱"    align="center"> </el-table-column>
                <el-table-column prop="user_retain.diff_seconds_describe"      label="停留时间"    align="center"> </el-table-column>
                <!-- <el-table-column prop="is_msg"      label="发送状态"    align="center"> 
                    <template slot-scope="scope"> 
                        <span v-if="scope.row.is_msg">
                            已发送
                        </span>
                        <span v-else>
                            未发送
                        </span>
                    </template>
                </el-table-column> -->
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        
        <!-- 弹框 -->
        <el-dialog :visible.sync="dialogVisible" width="30%"  :before-close="handleClose">
            <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="msg"></el-input>
            <m-upload class="m-upload" :img.sync="image"  :width="120" :height="120" file-name="image"  placement="right" />
            <span slot="footer" class="dialog-footer m-top">
                <el-input v-model="test_phone" placeholder="请输入测试号码" style="margin-right:30px"></el-input>
                <el-button type="info" @click="test(1)">测试发送</el-button>
                <el-button type="primary" @click="BulletVisible = true">发 送</el-button>
            </span>
        </el-dialog>
        <!-- 确认发送弹框 -->
        <el-dialog :visible.sync="BulletVisible" width="30%" :before-close="handleClose">
            <span>是否确认发送?</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleBatch(1)">发 送</el-button>
            </span>
        </el-dialog>
    </section>
</template>


<script>
import { member_send_activity_msg,member_reset_msg,user_retain } from '@/api/platform.js'
import MUpload from '../../../components/m-upload.vue'
export default {
    name: "UserList",
    components: { MUpload },
    data() {
        return {
            value: '',
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogVisible: false,
            msg: '',
            is_test: '',
            BulletVisible: false,
            image:'',
            test_phone:''
        }
    },
    methods: {
        // 搜索会员
        search() {
            this.page = 1;
            this.handleData()
        },
        // 获取会员数据
        handleData(){
            let params = {
                page:this.page
            }
            if(this.value != "") {
                params.keywords = this.value
            }
            user_retain(params).then(res => {
                if(res.code == 20000){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            }).catch(err => {
                console.log(err)
                this.tableData = []
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.role_id)
            })
        },
        // 正式发送
        handleBatch(){
            let params = {
                msg: this.msg,
                is_test: 0,
                img_url: this.image.url
            }
            member_send_activity_msg(3,params).then(res => {  
                if(res){
                    this.$message({type:'success',message:res.msg})
                    this.page = 1;
                    this.handleData()
                }
                this.BulletVisible = false
            })
        },
        // 测试发送
        test() {
            let params = {
                msg: this.msg,
                is_test: 1,
                img_url: this.image.url,
            }
            if(this.test_phone.trim() == '') {
                this.$message({type:'warning',message:'测试号码不能为空'})
                return false
            }
            params.test_phone = this.test_phone
            member_send_activity_msg(1,params).then(res => {  
                if(res){
                    this.$message({type:'success',message:res.msg})
                    this.page = 1;
                    this.handleData()
                }
                this.dialogVisible = false
            })
        },
        // 重置用户发送
        handelReset() {
            this.$confirm(`此操作将重置已发送用户，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                member_reset_msg(1).then(res => {
                    if(res) {
                        this.$message({type:'success',message:res.msg})
                        this.handleData();
                    }
                })
            }).catch(() => {})
        }
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 100px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
        .m-upload{
            margin-top: 20px;
        }
        .m-top {
            display: flex;
        }
    }
</style>